import {
  FLASHBACK_DUMMY_VIDEO,
  FLASHBACK_DUMMY_VIDEO_URL,
} from './flashbackEnv.ts';

declare global {
  interface Window {
    __NVR_PUBLIC_CONFIG__?: {
      API_BASE_URL?: string;
      VITE_API_BASE_URL?: string;
      FLASHBACK_DUMMY_VIDEO?: boolean | string;
      FLASHBACK_DUMMY_VIDEO_URL?: string;
    };
  }
}

/** Short CC0 sample used when dummy streaming is enabled and no custom URL is set. */
export const FLASHBACK_DEFAULT_DUMMY_VIDEO_URL =
  'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.webm';

function runtimeFlagTrue(v: unknown): boolean {
  if (v === true) return true;
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase();
    return s === '1' || s === 'true' || s === 'yes' || s === 'on';
  }
  return false;
}

/**
 * When true, live preview and live playback use a browser-playable sample file instead of HLS.
 * Enable with `FLASHBACK_DUMMY_VIDEO=true` in `.env`, or set
 * `window.__NVR_PUBLIC_CONFIG__.FLASHBACK_DUMMY_VIDEO = true` at runtime.
 */
export function isFlashbackDummyStreamEnabled(): boolean {
  if (typeof window !== 'undefined') {
    if (runtimeFlagTrue(window.__NVR_PUBLIC_CONFIG__?.FLASHBACK_DUMMY_VIDEO)) return true;
  }
  return FLASHBACK_DUMMY_VIDEO;
}

/** Resolved dummy `<video src>` URL (custom from env/runtime or built-in default). */
export function getFlashbackDummyVideoUrl(): string {
  if (typeof window !== 'undefined') {
    const rt = window.__NVR_PUBLIC_CONFIG__?.FLASHBACK_DUMMY_VIDEO_URL;
    if (typeof rt === 'string' && rt.trim() !== '') return rt.trim();
  }
  const fromEnv = FLASHBACK_DUMMY_VIDEO_URL.trim();
  return fromEnv || FLASHBACK_DEFAULT_DUMMY_VIDEO_URL;
}
